import {isAjaxReady} from "@/1_webapi/helpers";
import {BranchListMock, KeywordListMock, RankByBranchMock, RankByKeywordMock} from "@/1_webapi/mocks";
import {
    KeywordsListPositionHistoryQuery,
    RankByBranchPositionHistoryQuery,
    RankByKeywordPositionHistoryQuery
} from "@/1_webapi/query";
import store from "@/store";


export function baseUrl() {
    const path = window.location.pathname

    if (pathIsValid()) {
        const project_id = path.match(/projects\/(.*)\/localpack/)[1]
        return `/projects/${project_id}/localpack/`
    }
    else {
        throw new Error('Не удалось извлечь id проекта из пути:' + path)
    }

    function pathIsValid() {
        return /projects\//.test(path) && /localpack\//.test(path)
    }
}

class BaseDomainOperations {

    constructor() {
        this.rootStore = store
    }

    /**
     * Выполнить запрос
     * Можно изменить параметры перед отправкой
     * @param storeDomain {{query: BaseQuery}}
     * @param setParams {{Function}} - колбэк для изменения параметров запроса
     * @returns {Promise<void>}
     */
    async fetch(storeDomain, setParams = query => query, formData = false) {
        await isAjaxReady() // Ждём пока зарезолвится проверка загрузки general.js

        storeDomain.query._body.csrfmiddlewaretoken = window.getCookie('csrftoken')


        const prevQuery = storeDomain.query
        const query = prevQuery.cloneAndReset()
        storeDomain.query = query

        setParams(query)

        let request
        post(query, this.rootStore)

        // if (process.env.NODE_ENV === 'production') {
        //     post(query)
        // }
        // else {
        //     request = new Promise((resolve, reject) => {
        //         setTimeout(() => {
        //             resolve(this.responseMock)
        //         }, 1000)
        //     })
        // }

        return await request
            .then(response => {
                if (response === undefined || response === null) {
                    throw Error('API Error. Response is empty: ' + response)
                }

                query.response = response
                query.fulfilled()
                setHrefParams(query) // После успешного выполнения запроса, обновляем параметры в адресной строке
                return response
            })
            .catch(error => {
                storeDomain.query = prevQuery
                storeDomain.query.failed(error)
                throw error
            })

        //==//==//
        function post(query, rootStore) {
            query.pendingStart(rootStore.state.init)
            request = new Promise((resolve, reject) => {
                window._ajax({
                    href: baseUrl() + query.requestUrl,
                    post: formData ? objectToFormData(query.body) : query.body,
                    contentType: formData ? false : null,
                    processData: formData ? false : null,
                    success(response) {
                        resolve(response)
                    },
                });
            })
        }

        function get(query, rootStore) {
            query.pendingStart(rootStore.state.init.routeQuery)
            request = new Promise((resolve, reject) => {
                window._ajax({
                    href: baseUrl() + query.requestUrl__GET,
                    type: 'GET',
                    async: false,
                    success(response) {
                        resolve(response)
                    },
                });
            })
        }

        /**
         * Обновить параметры в адресной строке, в соответствии с запросом
         */
        function setHrefParams(query) {
            if (query.isType_mainOnPage) { // На странице может быть только один ключевой запрос, параметры которого нужно отражать в адресной строке.
                // console.log('AFTER REQUEST, setHrefParams', query._body.action, '=> ' + query.requestUrl)
                window.history.replaceState('', '', window.location.origin + window.location.pathname + query.requestUrl)
            }
        }

        function objectToFormData(obj) {
            const formData = new FormData()
            const keys = Object.keys(obj)
            keys.forEach(key => {
                formData.append(key, obj[key])
            })
            return formData
        }
    }

    async sortBy(storeDomain, payload) {
        await this.fetch(storeDomain, query => {
            const value = payload.isAscSort ? payload.sortingKey : '-' + payload.sortingKey
            query.setQueryParam({ key: 'order_by', value })
        }).then(response => {
            return response
        })
    }
}




class BaseDomainOperations_list extends BaseDomainOperations {
    responseMock

    constructor() {
        super()
    }

    async changePage(storeDomain, page) {
        await this.fetch(storeDomain, query => query.params.page = page).then(response => {
            return response
        })
    }

    async changePageSize(storeDomain, size) {
        await this.fetch(storeDomain, query => query.params.page_size = size).then(response => {
            return response
        })
    }
}

class BranchesOperations extends BaseDomainOperations_list {
    responseMock

    constructor() {
        super()
        this.responseMock = BranchListMock
    }

    async fetchList(storeDomain) {
        return await this.fetch(storeDomain)
    }
}

class BranchStatsOperations extends BaseDomainOperations_list {
    responseMock

    constructor() {
        super()
        this.responseMock = RankByBranchMock
    }

    async fetchList(storeDomain, branchId) {
        storeDomain.query.branchId(branchId)
        return await this.fetch(storeDomain)
    }
}

class KeywordsOperations extends BaseDomainOperations_list {
    responseMock

    constructor() {
        super()
        this.responseMock = KeywordListMock
    }

    async fetchList(storeDomain) {
        return await this.fetch(storeDomain)
    }
}

class KeywordStatsOperations extends BaseDomainOperations_list {
    responseMock

    constructor() {
        super()
        this.responseMock = RankByKeywordMock
    }

    async fetchList(storeDomain, keyword) {
        storeDomain.query.keyword(keyword)
        return await this.fetch(storeDomain)
    }
}

class CommonOperations extends BaseDomainOperations {
    constructor() {
        super()
    }

    async fetchProjectBranchesList(storeDomain) {
        return await this.fetch(storeDomain)
    }

    async fetchProjectSourcesList(storeDomain) {
        return await this.fetch(storeDomain)
    }


    async getKeywordsListPositionHistory(keyword, sourceId) {
        const query = new KeywordsListPositionHistoryQuery()
        query.setQueryParam({key: 'keyword', value: keyword})
        query.setQueryParam({key: 'source_id', value: sourceId})
        const response = await this.fetch({query}, query => query)
        return response.data.keywords[0][keyword]
    }

    async getRankByBranchPositionHistory(branchId, sourceId, keyword) {
        const query = new RankByBranchPositionHistoryQuery()
        query.setQueryParam({key: 'branch_id', value: branchId})
        query.setQueryParam({key: 'source_id', value: sourceId})
        query.setQueryParam({key: 'keyword', value: keyword})
        const response = await this.fetch({query}, query => query)
        return response.data.keywords[0][keyword]
    }

    async getRankByKeywordPositionHistory(branchId, sourceId, keyword) {
        const query = new RankByKeywordPositionHistoryQuery()
        query.setQueryParam({key: 'branch_id', value: branchId})
        query.setQueryParam({key: 'source_id', value: sourceId})
        if (keyword !== undefined) {
            query.setQueryParam({key: 'keyword', value: keyword})
        }
        const response = await this.fetch({query}, query => query)
        return response.data
    }

    async fetchBranchesUsesList(storeDomain) {

    }
}

class AboutRepometrHelpForm {
    async getUserFormData() {
        return new Promise((resolve, reject) => {
            window._ajax({
                href: '/ajax/localpack-help-form/',
                post: {
                    action: "get_user_form_data"
                },
                success(response) {
                    resolve(response.data)
                },
            });
        })
    }

    async createHelpRequest(payload) {
        return new Promise((resolve, reject) => {
            window._ajax({
                href: '/ajax/localpack-help-form/',
                post: {
                    action: "create_help_request",
                    name: payload.name,
                    phone: payload.phone,
                    email: payload.email,
                },
                success(response) {
                    resolve(response.data)
                },
            });
        })
    }
}

export class KeywordsManagementOperations extends BaseDomainOperations_list {
    constructor() {
        super()
    }

    // async fetchBranchesCards(storeDomain, branchId) {
    //     storeDomain.query._body.branch_id = branchId
    //     return await this.fetch(storeDomain, query => query)
    // }

    async fetchKeywords(storeDomain, branchId) {
        storeDomain.query._body.branch_id = branchId
        return await this.fetch(storeDomain, query => query)
    }

    // async addOneKeyword(storeDomain, payload = {
    //     branches_id_list: [],
    //     sources_id_list: [],
    //     keyword: null,
    // }) {
    //     const body = {
    //         ...storeDomain.query._body,
    //         ...payload,
    //     }
    //
    //     body.branches_id_list = JSON.stringify(body.branches_id_list)
    //     body.sources_id_list = JSON.stringify(body.sources_id_list)
    //     storeDomain.query._body = body
    //
    //     return await this.fetch(storeDomain, query => query)
    // }

    async addKeywordList(storeDomain, payload = {
        branches_id_list: [],
        sources_id_list: [],
        keyword_list: null,
    }) {
        const body = {
            ...storeDomain.query._body,
            ...payload,
        }

        body.branches_id_list = JSON.stringify(body.branches_id_list)
        body.sources_id_list = JSON.stringify(body.sources_id_list)
        storeDomain.query._body = body

        return await this.fetch(storeDomain, query => query)
    }

    async addKeywordFile(storeDomain, payload = {
        branches_id_list: [],
        sources_id_list: [],
        file: null,
    }) {
        const body = {
            ...storeDomain.query._body,
            ...payload,
        }

        body.branches_id_list = JSON.stringify(body.branches_id_list)
        body.sources_id_list = JSON.stringify(body.sources_id_list)
        storeDomain.query._body = body

        return await this.fetch(storeDomain, query => query, true)
    }

    async deleteKeyword(storeDomain, payload = {
        keywords_id_list: [],
    }) {
        const body = {
            ...storeDomain.query._body,
            ...payload,
        }

        body.keywords_id_list = JSON.stringify(body.keywords_id_list)
        storeDomain.query._body = body

        return await this.fetch(storeDomain, query => query)
    }
}

export class Api {
    constructor() {
        this.common = new CommonOperations()
        this.branches = new BranchesOperations()
        this.branchStats = new BranchStatsOperations()
        this.keywords = new KeywordsOperations()
        this.keywordStats = new KeywordStatsOperations()
        this.keywordsManagement = new KeywordsManagementOperations()
        this.aboutRepometrHelpForm = new AboutRepometrHelpForm()
    }
}





